<div class="comp-card">
  <div class="comp-header">
    <div class="comp-dot" [ngClass]="'dot-' + dotClass"></div>
    <div class="comp-body">
      <div class="comp-name" [class.deleted]="isRemoved">{{ commitment.title }}</div>
      <div class="comp-meta">
        <span class="chip" [ngClass]="'chip-def'" *ngIf="isRemoved">Dado de baja</span>
        <span class="chip" [ngClass]="'chip-' + assignedStatus.cssClass" *ngIf="!isRemoved">{{ assignedStatus.text }}</span>
        <span class="esg" *ngFor="let letter of esgActive">{{ letter }}</span>
        <span class="meta-text">Comunidad: {{ commitment.community || '—' }}</span>
        <span class="meta-text">Adhirió: {{ formatDate(commitment.adherenceDate) }}</span>
        <app-tx-link
          [txHash]="commitment.adherenceTxHash"
          [explorerUrl]="commitment.adherenceExplorerUrl"
        ></app-tx-link>
        <span class="meta-text meta-warning" *ngIf="!isRemoved && commitment.deadlineDate">
          Límite: {{ formatDate(commitment.deadlineDate) }}
        </span>
        <span class="chip chip-def" *ngIf="commitment.enabled === false">Compromiso deshabilitado</span>
      </div>
    </div>
    <button class="toggle-btn" type="button" (click)="toggle()">
      Historial
      <span class="expand-icon" [class.open]="expanded">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
        </svg>
      </span>
    </button>
  </div>

  <div class="comp-timeline" *ngIf="expanded">
    <div class="loading-note" *ngIf="loadingDetail">Cargando historial…</div>
    <div class="tl" *ngIf="!loadingDetail">
      <div class="tl-event" *ngFor="let row of timelineRows; trackBy: trackByRow" [ngClass]="'ev-' + row.cssClass">
        <app-activity-event-icon
          class="tl-icon"
          [iconKind]="row.iconKind"
          [tone]="rowTone(row.cssClass)"
        ></app-activity-event-icon>
        <div class="tl-row">
          <div
            class="tl-date"
            [matTooltip]="row.dateTime"
            matTooltipPosition="below"
          >
            <span class="tl-date-day">{{ row.date }}</span>
            <span class="tl-date-time">{{ row.time }}</span>
          </div>
          <div class="tl-main">
            <div class="tl-label">
              {{ row.label }}
              <app-tx-link [txHash]="row.txHash" [explorerUrl]="row.explorerUrl"></app-tx-link>
            </div>
            <div class="tl-doc" *ngFor="let doc of row.documentsAdded">
              <div class="tl-doc-head">
                <span class="tl-doc-name-text">{{ doc.name || ('Documento #' + doc.fileId) }}</span>
                <span class="hash-chip" title="Hash del documento (huella digital del archivo)">
                  <span class="hash-chip-label">Doc</span> {{ doc.hash?.slice(0, 6) }}…{{ doc.hash?.slice(-4) }}
                </span>
                <a class="ibtn" *ngIf="doc.url" [href]="doc.url" target="_blank" rel="noopener">Abrir</a>
              </div>
              <div class="tl-doc-thumb" *ngIf="docKindOf(doc.mimeType) === 'image' && doc.url">
                <img [src]="doc.url" [alt]="doc.name" loading="lazy" />
              </div>
            </div>
            <div class="tl-doc removed" *ngFor="let doc of row.documentsRemoved">
              <div class="tl-doc-head">
                <span class="tl-doc-name-text">{{ doc.name || ('Documento #' + doc.fileId) }}</span>
                <span class="hash-chip" title="Hash del documento (huella digital del archivo)">
                  <span class="hash-chip-label">Doc</span> {{ doc.hash?.slice(0, 6) }}…{{ doc.hash?.slice(-4) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      class="load-more-btn"
      type="button"
      *ngIf="hasMoreEvents"
      [disabled]="loadingMore"
      (click)="loadMore()"
    >
      {{ loadingMore ? 'Cargando…' : 'Cargar más eventos' }}
    </button>
  </div>
</div>
